import * as React from 'react';
import { useState } from "react";

export function useCustomerPickerVM() {
    const [value, setValue] = useState<number | undefined>(0);
    const [text, setText] = useState("");
    const [showMenu, setShowMenu] = useState(false);
    const [listHash, setListHash] = useState<number>(0);

    return {
        value,
        setValue,
        text,
        setText,
        showMenu,
        setShowMenu,
        listHash
    }
}